<template>
 <div>
    <b-button variant="success" size="sm" v-b-modal.modalAddUser>
      <font-awesome-icon :icon="['fas', 'plus']"/>
      Afegir usuaris
    </b-button>
    <!-- Modal Component -->
    <b-modal id="modalAddUser" centered ref="modalAddUser"  title="Afegir nou usuari">
        Usuaris a afegir:
        <v-select multiple
        placeholder="-- Selecciona els usuaris que vulguis afegir --"
        v-model="addedUsers"
        :options="this.users.filter(usuari => !this.ticket.usuaris.some(u => u.codi_xarxa === usuari))"/>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click.prevent="save">
          <font-awesome-icon :icon="['fas', 'check']"/>
          Desar
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  computed: {
    users () {
      return this.$store.state.users
    }
  },
  data () {
    return {
      addedUsers: null
    }
  },
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  methods: {
    save () {
      if (this.isNullOrUndefined(this.addedUsers)) {
        this.notifyError('Falta informació', 'Has d\'escollir usuaris a afegir')
      } else {
        this.$refs.modalAddUser.hide()
        var data = {
          ticketId: this.ticket.id,
          users: this.addedUsers,
          usuari: this.$store.getters.getUser.id
        }
        this.$store.dispatch('userFollowTicket', data).then(() => {
          this.addedUsers = null
          return this.addedUsers
        }, {})
      }
    }
  },
  created () {
    this.$store.dispatch('fetchUsers')
  }
}
</script>

<style scoped>
</style>
